export default function useTwitter() {
  function formatUsername(username: string) {
    // Remove '@' symbol from username or extract username from URL
    const twitterUsernameRegex =
      /(?:https?:\/\/)?(?:www\.)?(?:twitter\.com|x\.com)\/([a-zA-Z0-9_]+)/;
    const match = username.match(twitterUsernameRegex);
    return match ? match[1] : username.replace("@", "");
  }

  return {
    formatUsername,
  };
}
